import { render, staticRenderFns } from "./ScottyBeamMeUp.vue?vue&type=template&id=610129be&scoped=true"
import script from "./ScottyBeamMeUp.vue?vue&type=script&lang=js"
export * from "./ScottyBeamMeUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610129be",
  null
  
)

export default component.exports